import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';
import Logo from '../Navigation/Logo';
import { Search, FileCheck, Shield, Scale, Database, BookOpen, Mail } from 'lucide-react';

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 }
  }
};

const navItems = [
  { 
    label: 'Solutions', 
    href: '/use-cases',
    dropdown: [
      { 
        id: 'data-discovery',
        label: 'Data Discovery', 
        href: '/use-cases/data-discovery-and-classification',
        icon: Search
      },
      { 
        id: 'data-classification',
        label: 'Data Classification', 
        href: '/use-cases/data-discovery-and-classification',
        icon: FileCheck
      },
      { 
        id: 'data-detection-response',
        label: 'Data Detection & Response', 
        href: '/use-cases/data-detection-response',
        icon: Shield
      },
      { 
        id: 'data-compliance',
        label: 'Data Compliance', 
        href: '/use-cases/data-compliance',
        icon: Scale
      },
      { 
        id: 'data-governance',
        label: 'Data Governance', 
        href: '/use-cases/data-governance',
        icon: Database
      }
    ]
  },
  { 
    label: 'Resources', 
    href: '/resources',
    dropdown: [
      { 
        id: 'blog',
        label: 'Blog', 
        href: '/blog',
        icon: BookOpen
      },
      { 
        id: 'contact',
        label: 'Contact Us', 
        href: '/contact',
        icon: Mail
      }
    ]
  }
];

const Footer = () => {
  return (
    <footer className="bg-gradient-background border-t border-gray-800 relative">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-secondary/10 to-accent/10" />
      
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12 items-start">
          {/* Logo */}
          <div className="md:col-span-4">
            <motion.div
              initial="hidden"
              animate="visible"
              variants={fadeInUp}
              className="space-y-4"
            >
              <div className="flex flex-col items-start">
                <div className="">
                  <Logo color="white" showText={false} size="large" />
                </div>
                <div className="flex flex-col items-start mt-8">
                  <p className="text-white">
                    800 Park Offices Drive, Suite 3512
                  </p>
                  <h6 className="text-white">
                    Durham, NC 27713, U.S.A.
                  </h6>
                </div>
                <div>
                  
                </div>
              </div>
            </motion.div>
          </div>

          {/* Navigation Links */}
          <div className="md:col-span-6 grid grid-cols-2 gap-8">
            {navItems.map((item, sectionIndex) => (
              <div key={item.label}>
                <motion.div
                  initial="hidden"
                  animate="visible"
                  variants={fadeInUp}
                  custom={sectionIndex}
                  className="space-y-4"
                >
                  <h3 className="text-white font-semibold">{item.label}</h3>
                  <ul className="space-y-2">
                    {item.dropdown ? (
                      item.dropdown.map((dropdownItem) => (
                        <li key={dropdownItem.id}>
                          <Link
                            to={dropdownItem.href}
                            className="text-gray-300 hover:text-primary transition-colors"
                          >
                            {dropdownItem.label}
                          </Link>
                        </li>
                      ))
                    ) : (
                      <li>
                        <Link
                          to={item.href}
                          className="text-gray-300 hover:text-primary transition-colors"
                        >
                          {item.label}
                        </Link>
                      </li>
                    )}
                  </ul>
                </motion.div>
              </div>
            ))}
          </div>

          {/* SOC Logo */}
          <div className="md:col-span-2 flex justify-end">
            <motion.div
              initial="hidden"
              animate="visible"
              variants={fadeInUp}
            >
              <img 
                src="/assets/images/soc-logo.png" 
                alt="SOC Logo" 
                className="h-40 w-auto"
              />
            </motion.div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <motion.div
              initial="hidden"
              animate="visible"
              variants={fadeInUp}
              className="text-gray-300 hover:text-primary transition-colors"
            >
              <a 
                href="/assets/documents/Privacy Policy - ANCILE - 2025.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </motion.div>
            <motion.div
              initial="hidden"
              animate="visible"
              variants={fadeInUp}
              className="text-white"
            >
              © {new Date().getFullYear()} Ancile. All rights reserved.
            </motion.div>
            <SocialLinks />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;